import { FREIGHT_TYPE, PRODUCT_TYPES } from '@schuettflix/interfaces';

export const productTypeToFreightTypeMap = {
    // =================================
    // Handled by custom-request-service
    // =================================
    // Materials
    CUSTOM_BULK_MATERIAL: 'BULK_MATERIAL',
    CUSTOM_RECYCLED_BULK_MATERIAL: 'RECYCLING_BULK_MATERIAL',
    CUSTOM_CONCRETE: 'CONCRETE',
    CUSTOM_ASPHALT: 'ASPHALT',
    // Waste
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'HAZARDOUS_WASTE',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'HAZARDOUS_WASTE',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'NON_HAZARDOUS_WASTE',
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: 'NON_HAZARDOUS_WASTE',
    // Transports
    CUSTOM_TRANSPORT: undefined,
    // Material Services
    CUSTOM_SERVICE: undefined,
    CUSTOM_SERVICE_ANALYSIS: undefined,
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: undefined,
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: undefined,
    CUSTOM_SERVICE_TOLL: undefined,
    CUSTOM_SERVICE_WAITING_TIME: undefined,
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: 'BULK_MATERIAL',
    RECYCLED_BULK_MATERIAL: 'RECYCLING_BULK_MATERIAL',
    // Waste
    HAZARDOUS_WASTE_DISPOSAL: 'HAZARDOUS_WASTE',
    HAZARDOUS_WASTE_RECYCLING: 'HAZARDOUS_WASTE',
    NON_HAZARDOUS_WASTE_DISPOSAL: 'NON_HAZARDOUS_WASTE',
    NON_HAZARDOUS_WASTE_RECYCLING: 'NON_HAZARDOUS_WASTE',
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: undefined,
    // ============================
    // Not Handled by any channel
    // ============================
    SERVICE_TOLL: undefined,
    SERVICE_WEIGHING_NOTE: undefined,
    SERVICE_ACCOMPANYING_DOCUMENT: undefined,
    SERVICE_ENERGY_SURCHARGE: undefined,
} as const satisfies Record<PRODUCT_TYPES, FREIGHT_TYPE | undefined>;
